import { ApiService } from "./ApiService"

export class PopImageService {

    static uri = '/pop-image';

    static create({ data, popId }) {
        return ApiService.post(`${this.uri}/create/${popId}`, data, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
                'Content-Type': 'multipart/form-data'
            }
        });
    }

    static delete({ id }) {
        return ApiService.post(`${this.uri}/delete/${id}`, {}, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`
            }
        });
    }
}